module.exports = __webpack_public_path__ + "img/arrow_left_black.b58b3cc6.svg";